import { YEATIES_PRIVACY_PATH } from "@/features/legal/config/yeatiesPrivacy.config";
import { YEATIES_TERMS_PATH } from "@/features/legal/config/yeatiesTerms.config";
import type { RouteConfig } from "@/router/types";
import { lazyWithRetry } from "@/shared/utils/lazyWithRetry";

const CGVPage = lazyWithRetry(() => import("@/features/legal/pages/CGVPage"));
const YeatiesTermsPage = lazyWithRetry(() => import("@/features/legal/pages/YeatiesTermsPage"));
const YeatiesPrivacyPage = lazyWithRetry(() => import("@/features/legal/pages/YeatiesPrivacyPage"));

const legalRoutes: RouteConfig[] = [
  {
    path: "/cgv-billeterie",
    element: <CGVPage />,
    isProtected: true,
    useMainLayout: true,
  },
  // Public routes, no authentication required
  {
    path: YEATIES_TERMS_PATH,
    element: <YeatiesTermsPage />,
    isProtected: false,
    useMainLayout: false,
  },
  {
    path: YEATIES_PRIVACY_PATH,
    element: <YeatiesPrivacyPage />,
    isProtected: false,
    useMainLayout: false,
  },
];

export default legalRoutes;
